import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Shell, KpiCard, Section, StatusPill } from "@/components/loomi/Layout";
import { CLIENT_NAV } from "./ClientDashboard";
import { api } from "@/lib/api";
import { LogsTable } from "../admin/AdminProjectDetail";

export default function ClientProjectDetail() {
  const { pid } = useParams();
  const [p, setP] = useState(null);
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    (async () => {
      const [pj, lg] = await Promise.all([api.get(`/client/projects/${pid}`), api.get(`/client/projects/${pid}/logs`)]);
      setP(pj.data); setLogs(lg.data);
    })();
  }, [pid]);
  if (!p) return <Shell title="Loading…" portalLabel="Client" nav={CLIENT_NAV}><div className="text-mute">Loading…</div></Shell>;
  const c = p.counters || {};
  return (
    <Shell title={p.name} portalLabel="Client" nav={CLIENT_NAV}>
      <div className="flex items-center gap-3 mb-6">
        <StatusPill status={p.status} />
        <span className="text-xs uppercase tracking-widest text-mute">{p.type}</span>
        <span className="text-[10px] uppercase tracking-widest text-mute ml-auto">Read-only</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-4">
        <KpiCard label="Starts" value={c.starts || 0} accent="blue" testId="cpd-starts" />
        <KpiCard label="Complete" value={c.complete || 0} accent="green" testId="cpd-complete" />
        <KpiCard label="Terminate" value={c.terminate || 0} accent="red" testId="cpd-terminate" />
        <KpiCard label="Overquota" value={c.overquota || 0} accent="amber" testId="cpd-overquota" />
        <KpiCard label="Quality-T" value={c.quality_term || 0} accent="red" testId="cpd-quality" />
        <KpiCard label="Security-T" value={c.security_term || 0} accent="red" testId="cpd-security" />
      </div>
      <div className="mt-8 grid md:grid-cols-2 gap-6">
        <Section title="Project details" testId="section-client-project-details">
          <dl className="grid grid-cols-2 gap-y-3 gap-x-6 text-sm">
            <Meta k="Target N" v={p.target_n} />
            <Meta k="CPI" v={`$${(p.cpi || 0).toFixed(2)}`} />
            <Meta k="LOI" v={`${p.loi} min`} />
            <Meta k="Incidence" v={`${p.incidence_rate}%`} />
          </dl>
        </Section>
        <Section title="Redirect logs" testId="section-client-logs">
          <LogsTable logs={logs} />
        </Section>
      </div>
      <div className="mt-6 text-xs text-mute">
        <Link to="/client" className="hover:text-white" data-testid="client-back-overview">← back to overview</Link>
      </div>
    </Shell>
  );
}
function Meta({ k, v }) { return (<div><div className="text-[10px] uppercase tracking-widest text-mute">{k}</div><div className="text-sm">{v}</div></div>); }
